import React, { useState, useEffect } from 'react';
import { getCandidates, acceptCandidate, rejectCandidate, Candidate } from '../repository/listRepository';

export const CandidateReview: React.FC = () => {
  const [candidates, setCandidates] = useState<Candidate[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCandidates = () => {
    getCandidates().then(setCandidates).finally(() => setLoading(false));
  };

  useEffect(() => { fetchCandidates(); }, []);

  const handleAccept = async (id: string) => {
    await acceptCandidate(id);
    fetchCandidates();
  };

  const handleReject = async (id: string) => {
    await rejectCandidate(id);
    fetchCandidates();
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <h1 className="page-title">Pending Candidates</h1>

      {candidates.length === 0 ? (
        <div className="empty-state"><p>No pending candidates.</p></div>
      ) : (
        candidates.map(c => (
          <div key={c.uuid} className="candidate-card">
            <div className="candidate-title">{c.title}</div>
            <div className="candidate-meta">
              {c.source && <>from {c.source} &middot; </>}
              {new Date(c.created_at).toLocaleDateString()}
            </div>
            {c.notes && <p className="item-notes">{c.notes}</p>}
            <div className="candidate-actions">
              <button onClick={() => handleAccept(c.uuid)} className="btn btn-sm btn-primary">Accept</button>
              <button onClick={() => handleReject(c.uuid)} className="btn btn-sm btn-danger">Reject</button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
